/**
 * Error callback for Apollo observable `.subscribe({ next, error })` calls.
 *
 * Without an `error` handler, zen-observable rethrows the error inside a
 * `setTimeout` (`hostReportError`), which reaches Sentry as an unreadable
 * synthetic event like "Object captured as exception with keys: message"
 * (see CRM-WEB-5D). Network/WS errors are already logged by the Apollo
 * errorLink, so logging here is enough.
 */
export const logSubscriptionError =
  (source: string) =>
  (error: unknown): void => {
    console.error(`[${source}] subscription error`, error);
  };
